var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowMoreIconOptions = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 3 3"
}, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFF",
  points: "2,2 2,1 1,1 1,0 0,0 0,3 3,3 3,2"
})));
export default SvgArrowMoreIconOptions;